export const Texts = {
  titulo: 'Reportes',
  subtitulo:
    'Genera reportes según los filtros que tu definas basados en los datos ingresados en la plataforma.',
  opciones: {
    personalizado: {
      titulo: 'Personalizado',
      descripcion:
        'Podrás seleccionar manualmente el nivel de los registros de los cuales quieres obtener el reporte, grupo, negocio o sucursal.'
    },
    completo: {
      titulo: 'Completo,',
      descripcion:
        'Se exportarán todas los negocios registrados en sistema junto con todas sus sucursales.'
    },
    sinader: {
      titulo: 'SINADER',
      descripcion: ` Se exportarán las transacciones finalizadas de
                      residuo-recurso del <strong>Marketplace</strong> y
                      residuos declarados en <strong>Gestiona</strong>, en
                      formato apto para la opción "carga masiva de residuos", de
                      las declaraciones mensuales en la plataforma SINADER.`
    }
  },
  botonDescargar: 'Descargar'
};

export const DATO_A_EXPORTAR = {
  USUARIO: 'Usuario',
  RESIDUO: 'Residuo',
  INDICADOR: 'Indicador',
  RESIDUO_DECLARADO: 'Residuo declarado',
  RECURSO_ADQUIRIDO: 'Recurso adquirido'
};

export const TIPO_REPORTE = {
  PERSONALIZADO: 'personalizado',
  COMPLETO: 'completo',
  SINADER: 'sinader'
};

export const INIT_DATA = {
  fechaDisponibilidadInicio: null,
  fechaDisponibilidadInicio_str: null,
  fechaDisponibilidadTermino: null,
  fechaDisponibilidadTermino_str: null,
  formato: 'xlsx',
  tipoExportacion: 'Residuo',
  codigoEmpresa: null,
  periodo: 'anual',
  anyo: new Date(),
  mesAnyo: new Date(),
  grupo: {},
  negocios: [],
  sucursales: []
};
